import { useTranslation } from 'react-i18next';
import { Dialog } from 'src/components/Dialog';

interface UnsavedChangesDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
}

/**
 * Dialog component for confirming navigation when there are unsaved changes
 *
 * This provides a better UX than the browser's native beforeunload dialog
 * for internal navigation within the React app.
 */
export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onConfirm,
  onCancel,
  title,
  message,
}) => {
  const { t: tCommon } = useTranslation('translation', {
    keyPrefix: 'common',
  });

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title={title || tCommon('unsavedChanges.title')}
      actions={[
        {
          label: tCommon('buttons.stayOnPage'),
          onClick: onCancel,
          color: 'primary',
        },
        {
          label: tCommon('buttons.leaveWithoutSaving'),
          onClick: onConfirm,
          color: 'error',
          variant: 'outlined',
        },
      ]}
    >
      {message || tCommon('unsavedChanges.message')}
    </Dialog>
  );
};
